import { store } from "@davstack/store";
import { IContribution } from "../types";
import {
  getContributionsRequest,
  searchContributionsRequest,
  createContributionRequest,
  updateContributionRequest,
  getContributionByIdRequest
} from "../services/contributions/contributions.api";
import { createCSStore } from "./newStores";

type ContributionsStoreType = {
  contributions: IContribution[];
  isLoading: boolean;
}

export const contributionsStore = createCSStore("ContributionsStore")
  .state<ContributionsStoreType>({
    contributions: [],
    isLoading: false
  })
  .actions((store) => ({
    loadContributions: async () => {
      store.isLoading.set(true);
      try {
        const response = await getContributionsRequest();
        const contributions = response.response.data;
        store.contributions.set(contributions);
      } catch (error) {
        console.error('Error loading contributions:', error);
      } finally {
        store.isLoading.set(false);
      }
    },

    searchContributions: async (searchQuery: string) => {
      store.isLoading.set(true);
      try {
        const response = await searchContributionsRequest(searchQuery);
        const contributions = response.response.data;
        store.contributions.set(contributions);
      } catch (error) {
        console.error('Error searching contributions:', error);
      } finally {
        store.isLoading.set(false);
      }
    },

    createContribution: async (data: Omit<IContribution, 'id'>, memberId: string) => {
      store.isLoading.set(true);
      try {
        const response = await createContributionRequest({...data, member: memberId});
        const newContribution = response.response.data;
        store.contributions.set([...store.contributions.get(), newContribution]);
        return newContribution;
      } catch (error) {
        console.error('Error creating contribution:', error);
        throw error;
      } finally {
        store.isLoading.set(false);
      }
    },

    updateContribution: async (id: string, data: Partial<IContribution>) => {
      store.isLoading.set(true);
      try {
        const response = await updateContributionRequest({ id, ...data });
        const updatedContribution = response.response.data;
        const currentContributions = store.contributions.get();
        const updatedContributions = currentContributions.map((contribution: IContribution) =>
          contribution.id === id ? updatedContribution : contribution
        );
        store.contributions.set(updatedContributions);
        return updatedContribution;
      } catch (error) {
        console.error('Error updating contribution:', error);
        throw error;
      } finally {
        store.isLoading.set(false);
      }
    },

    getContributionById: async (id: string): Promise<IContribution | undefined> => {
      // First check if contribution exists in current store
      const contributions = store.contributions.get();
      let contribution = contributions.find((contribution: IContribution) => 
        contribution.id.toString() === id.toString()
      );
      
      // If not found locally, fetch from server
      if (!contribution) {
        try {
          store.isLoading.set(true);
          const response = await getContributionByIdRequest(id);
          contribution = response.response.data;
          
          // Add the fetched contribution to the store
          if (contribution) {
            const currentContributions = store.contributions.get();
            store.contributions.set([...currentContributions, contribution]);
          }
        } catch (error) {
          console.error('Error fetching contribution by id:', error);
        } finally {
          store.isLoading.set(false);
        }
      }
      
      console.log({id, contributions, contribution});
      return contribution;
    }
  })); 